import React from 'react';
import BrandTitle from 'components/common/BrandTitle';
import DesktopBanner from 'components/common/DesktopBanner';

import {
  Link,
} from 'react-router-dom';

import useResponsive from 'hooks/useResponsive';

import { BodyHeader } from './styles';

const Header = () => {
  const { isLargeView } = useResponsive();

  if (isLargeView) {
    return null;
  }

  return (
    <BodyHeader>
      <Link to="/search"><BrandTitle /></Link>

    </BodyHeader>
  );
};

export default Header;
